import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

import saveAs from 'file-saver';
import moment from 'moment';
import InfoModal from './InfoModal'
import Checkbox from './Checkbox'

import useUserManagement from '../../../hooks/useUserManagement'

const HasTemplate = (props) => {
    const visible = props.visible
    const disabled = props.disabled || false
    const templateID = props.templateID || null
    const templateData = props.templateData
    const filename = props.filename
    const onDownloadOnSaveChange = props.onDownloadOnSaveChange
    const downloadOnSave = props.downloadOnSave
    const showModal = props.showModal
    const onModalClose = props.onModalClose
    const showSharePointInfo = props.showSharePointInfo
    const entityType = props.entityType || "Document"
    const sharePointInfo = ( entityType === "Document" )
                         ? "Save SMART Template file to SharePoint. GNC Go will add a link in the Original (Editable) file location field."
                         : "Save SMART Template file to SharePoint. GNC Go will add a link in the file location field below."
    
    const label = templateData ? "SMART Template" : "Template"

    const { getUserFromID } = useUserManagement()
    const [ templates, setTemplates ] = useState([])
    const [ template, setTemplate ] = useState({})
    const [ templatePlaceholders, setTemplatePlaceholders ] = useState([])
    const [ isDownloading, setIsDownloading ] = useState(false)
    const [ isDownloaded, setIsDownloaded ] = useState(false)
    const [ isUploading, setIsUploading ] = useState(false)
    const [ uploadResult, setUploadResult ] = useState(null)
    const [ uploadError, setUploadError ] = useState(null)
    
    useEffect(() => {
        fetch('/v0/templates', { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                setTemplates(json.results)
            })
    }, [])

    useEffect(() => {
        fetch('/v0/template_placeholders', { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                setTemplatePlaceholders(json.results)
            })
    }, [])

    useEffect(() => {
        setTemplate(templates?.find(element => element.id === templateID))
    }, [templateID, templates])
        
    const viewTemplate = (contents, filetype, filename) => {
        let content = atob(contents)
        let bytes = new Uint8Array(content.length);
        for (let i = 0; i < bytes.length; i++) {
            bytes[i] = content.charCodeAt(i);
        }

        let blob = new Blob([bytes], { type: filetype })
        let url = URL.createObjectURL(blob);
        saveAs(blob, filename + template?.file_extension);
    }

    const getTemplateContents = () => {
        const url = '/v0/templates/'+templateID+'/contents'
        fetch(url, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'GET'
        }).then(function(response) {
            return response.json()
        }).then(function(json) {
            viewTemplate(json.result.contents, template.filetype, filename)
        })
    }

    const getTemplateContentsWithData = () => {
        setIsDownloading(true)
        setIsDownloaded(false)
        
        const url = '/v0/templates/'+templateID+'/contents/with_data'
        
        const rawData = templateData()

        //
        //const map = [
        //    { attribute: "project.name", placeholder: "p_name" },
        //    { attribute: "reference", placeholder: "ref" },
        //    { attribute: "reference", placeholder: "FOOBAR" },
        //    { attribute: "yahla", placeholder: "spam" },
        //]

        let data = {}
        for (const p of templatePlaceholders) {
            const key = p.attribute
            const placeholder = p.placeholder
            
            let objValue = rawData[key]
            if (key.match(/\./)) {
                const parts = key.split('.')
                objValue = rawData
                while(parts.length) {
                    if (typeof objValue === 'undefined' || objValue === null) {
                        break
                    }
                    objValue = objValue[parts.shift()]
                }
            }
            
            if (key.match(/user_id$/)) {
                const user = getUserFromID(objValue)
                objValue = user.forename + " " + user.surname
            }
            
            if (key.match(/date$/)) {
                if (typeof objValue === 'undefined' || objValue === null) {
                    objValue = ''
                } else {
                    try {
                        // format date, if exists
                        var date = moment.utc(objValue)
                        objValue = date.format('DD-MM-YYYY')
                    } catch (e) {
                        objValue = ''
                    }
                }
            }
            
            if (typeof objValue === 'undefined' || objValue === null) {
                continue
            }
            
            data[placeholder] = objValue
        }
                                                     
        fetch(url, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(data)
        }).then(function(response) {
            return response.json()
        }).then(function(json) {
            setIsDownloading(false)
            setIsDownloaded(true)
            viewTemplate(json.result.contents, template.filetype, filename)
        })
    }
                                                     
    if (!visible || disabled) {
        return null
    }
    
    if (!templateID || templateID === 0 || template === undefined) {
        // No template
        return (
            <div className="form-group">
                <label className="col-sm-2 control-label">{label}</label>
                <div className="col-sm-8" style={{paddingTop: '7px'}}>
                    No Template available
                </div>
            </div>
        )
    }
    
    let onClick = templateData
                ? getTemplateContentsWithData
                : getTemplateContents
    

    if (!templateData) {
        // This is like in Cadm Admin / Types stuff
        return (
            <div className="form-group">
                <label className="col-sm-2 control-label">{label}</label>
                <div className="col-sm-8" style={{paddingTop: '7px'}}>
                    <Link onClick={onClick}>{filename}</Link>
                </div>
            </div>
        )
    }

    const bodyContent = (
        <>
        <p>Click below to start working from a {label}</p>
        
        <div>
            <a href="#" onClick={onClick}>{filename}{template?.file_extension}</a>
            <span className="help-block m-b-none">
                &nbsp;
                {isDownloading &&
                 <span className="has-spinner active">
                     <span className="psc-spinner"><i className="fa fa-refresh fa-spin fa-fw"></i></span>
                     Fetching...
                 </span>
                }
                {isDownloaded &&
                 <span>Done (your template will open in your default application)</span>
                }
            </span>
            
        </div>
        </>
    )
    
    return (
        <>
        <InfoModal
            titleIcon="fa fa-file-text"
            title="Download a SMART Template"
            bodyContent={bodyContent}
            show={showModal}
            onClose={onModalClose}
        />
        <div className="form-group">
            <label className="col-sm-2 control-label">{label}</label>
            <div className="col-sm-8" style={{paddingTop: '7px'}}>
                <div className="form-check">
                    <Checkbox
                        id="download-on-save"
                        name="download-on-save"
                        onChange={() => onDownloadOnSaveChange(!downloadOnSave)}
                        isChecked={downloadOnSave}
                    />
                    <label htmlFor="download-on-save">
                        Download on Save
                    </label>
                </div>
                {showSharePointInfo &&
                 <span className="help-block m-b-none m-t-none">
                   <small className="form-info-text"> {sharePointInfo} </small>
                 </span>
                }
            </div>
        </div>
        </>
    )
}

export default HasTemplate
